import {Component, Input, OnInit} from '@angular/core';
import {MemberManagementService} from './member-management.service';
import {EnumModel} from '../../shared/objects/EnumModel';
import {MemberGridConfiguration, MemberRequestModel} from './member-management.model';
import {StatisticsGroupModel} from '../../shared/objects/statistics-group.model';
import {TokenManagerService} from '../../shared/services/token-login.service';

@Component({
  selector: 'app-member-management',
  providers: [MemberManagementService],
  templateUrl: './member-management.component.html',
  styleUrls: ['./member-management.component.less']
})
export class MemberManagementComponent implements OnInit {
  @Input() managerAdmin: boolean;

  showMember = false;
  memberId: number;
  searchValue: string;
  selectedMembers: any[];
  isUserAdmin: boolean;

  showExpiryDates = false;
  showAddInvites = false;
  selectedExpiryDate: EnumModel;
  expiryDateOptions: EnumModel[];
  statisticsGroupModel: StatisticsGroupModel[];


  memberGridConfiguration: MemberGridConfiguration;
  memberGridRequest: MemberRequestModel;

  showMessage = null;

  constructor(private memberService: MemberManagementService) {

  }

  ngOnInit() {
    this.isUserAdmin = TokenManagerService.isAdmin() || this.managerAdmin;
    this.memberGridConfiguration = new MemberGridConfiguration();
    this.memberGridConfiguration.service = this.memberService;
    this.memberGridRequest = new MemberRequestModel();
    this.memberGridConfiguration.onRowClick.subscribe((e) => this.show(e.data.id));

    this.selectedExpiryDate = new EnumModel('3', '3 months');
    this.expiryDateOptions = new Array<EnumModel>();

    this.expiryDateOptions.push(this.selectedExpiryDate);
    this.expiryDateOptions.push(new EnumModel('6', '6 months'));
    this.expiryDateOptions.push(new EnumModel('12', '12 months'));
    this.expiryDateOptions.push(new EnumModel('unlimited', 'unlimited'));

    this.memberService.getMembersAnalytics()
      .subscribe(
        (response) => {
          this.statisticsGroupModel = response;
        },
        (error) => console.log(error)
      );

  }

  show(memberId) {
      this.memberId = memberId;
      this.showMember = true;
  }

  expiry() {
    if (this.memberGridConfiguration.getSelected().length === 0) {
      this.showMessage = 'No members selected.';
    } else {
      this.selectedMembers = this.memberGridConfiguration.getSelected();
      this.showExpiryDates = true;
      console.log(this.memberGridConfiguration.dataGrid.instance.getSelectedRowsData());
    }
  }

  exportData() {
    if (this.memberGridConfiguration.getSelected().length === 0) {
      this.showMessage = 'No members selected.';
    } else {
      this.memberGridConfiguration.dataGrid.instance.exportToExcel(true);
      this.refreshGrid();
    }
  }
  invite() {
    if (this.memberGridConfiguration.getSelected().length === 0) {
      this.showMessage = 'No members selected.';
    } else {
      this.selectedMembers = this.memberGridConfiguration.getSelected();
      this.showAddInvites = true;
    }
  }
  closePopUp(refresh) {
    this.showAddInvites = false;
    this.showMessage = null;
    this.showExpiryDates = false;
    this.showMember = false;
    if (refresh) {
      this.refreshGrid();
    }
  }
  refreshGrid() {
    this.memberGridConfiguration.reloadGrid();
  }

  search(value) {
    this.memberGridConfiguration.customSearch[0].value = value;
    this.memberGridConfiguration.dataGrid.instance.getDataSource().reload();
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-management.component.ts